import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  minBreakpointQuery,
  standardColours,
} from '../styles';
import { Svg } from './ui';
import quotemarks from '../images/quotemarks.inline.svg';

const StyledReviewCard = styled.figure`
  border-radius: 30px;
  background-color: ${standardColours.white};
  margin: 0;
`;

const StyledInner = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  height: 100%;

  ${minBreakpointQuery.small`
    padding: 35px;
  `}

  ${minBreakpointQuery.large`
    padding: 40px;
  `}
`;

const StyledContent = styled.blockquote`
  margin: 0 0 20px 0;

  ${minBreakpointQuery.small`
    margin-bottom: 30px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 40px;
  `}
`;

const StyledQuotemarks = styled(Svg)`
  width: 28px;
  height: 20px;
  transform: scaleX(-1);
  margin-bottom: 10px;
  fill: ${brandColours.quaternary};

  ${minBreakpointQuery.small`
    width: 42px;
    height: 30px;
  `}

  ${minBreakpointQuery.smedium`
    margin-bottom: 20px;
  `}

  ${minBreakpointQuery.large`
    width: 56px;
    height: 40px;
  `}
`;

const StyledHeading = styled.h3`
  font-weight: ${fontWeights.semibold};
  margin-bottom: 10px;
  ${fontSize(16)};

  ${minBreakpointQuery.small`
    ${fontSize(18)};
    margin-bottom: 15px;
  `}

  ${minBreakpointQuery.large`
    ${fontSize(20)};
  `}
`;

const StyledText = styled.p`
  line-height: 1.5;
`;

const StyledFooter = styled.figcaption`
  margin-top: auto;
`;

const StyledCite = styled.cite`
  font-style: normal;
  font-weight: ${fontWeights.semibold};

  span {
    display: block;
  }
`;

const ReviewCard = ({ title, review, authorRole, companyLocation }) => (
  <StyledReviewCard>
    <StyledInner>
      <StyledContent>
        <StyledQuotemarks image={quotemarks} />
        <StyledHeading>{title}</StyledHeading>
        <StyledText>{review}</StyledText>
      </StyledContent>
      <StyledFooter>
        <StyledCite>
          {authorRole}, <span>{companyLocation}</span>
        </StyledCite>
      </StyledFooter>
    </StyledInner>
  </StyledReviewCard>
);

export default ReviewCard;

export const ReviewCardFragment = graphql`
  fragment ReviewCardFragment on DatoCmsReview {
    title
    review
    authorRole
    companyLocation
  }
`;
